/** The confidence groups of the response, in the order they are presented. */
export const HUBSPOT_IMPORT_MATCH_GROUPS = [
  'highConfidence',
  'lowConfidence',
  'noMatch',
] as const;

/**
 * The score from which a match counts as high confidence. The backend returns
 * one flat list of matches with a score each, so the grouping the review step
 * presents is drawn here rather than by the API.
 */
export const HIGH_CONFIDENCE_SCORE_THRESHOLD = 92;

/**
 * The column the backend should resolve the supplier name from.
 */
export const HUBSPOT_IMPORT_DEFAULT_NAME_COLUMN = 'Deal-Name';

/**
 * The column the backend should resolve the supplier customer number from.
 */
export const HUBSPOT_IMPORT_DEFAULT_CUSTOMER_NUMBER_COLUMN = 'Customer-Number';
